import React, { useEffect } from 'react'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import {
	showImagesSelector} from '../../../redux/selectors'
import AlbumsContainer from './components/AlbumsContainer'
import ImagesContainer from './components/ImagesContainer';
import StyledWrapper from '../../../components/StyledWrapper'
import { goToAlbumView } from '../../../redux/actions';

const Images = ({showImages, goToAlbumView}) => {
	useEffect(() => {
		goToAlbumView()
	}, [])

	return (
		<StyledWrapper>
			{showImages ? <ImagesContainer data-testid="page-albums-container" /> : <AlbumsContainer data-testid="page-albums-container" />}
		</StyledWrapper>
	)
}

const mapStateToProps = (state) => ({
	showImages: showImagesSelector(state)
})

const mapDispatchToProps = (dispatch) => ({
	goToAlbumView: () => dispatch(goToAlbumView())
})

const enhance = compose(connect(mapStateToProps, mapDispatchToProps))

export default enhance(Images)
